import React, { Component } from 'react';
import { Icons } from '@/configurations'
import { connect } from 'react-redux';
import { getSafe } from '@/helpers/global';
import { accessibilityFunctions, keyDownFunctions } from '@/helpers/functions';

import '@/assets/styles/components/tab-header/radio-options.scss';

class RadioOptions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      options: [],
      selectedOptionIndex: 0,
    }
  }

  render() {
    const { language, direction } = this.props;
    const { options, selectedOptionIndex } = this.state;
    return (
      <div  className={`radio-options-container flex h-100 ${direction === 'vertical' ? 'flex-col' : ''}`}>
	    {options.map((opt, index) =>
	        <div key={opt.value}  
			   className={`radio-item ${index === selectedOptionIndex ? 'radio-item-active' : ''} flex flex-align-center`}
			   onClick={() => this.handleClickOption(opt, index)}
         onKeyDown={keyDownFunctions.handleEnterKeyDown(() => this.handleClickOption(opt, index))}
         {...accessibilityFunctions.hasTabIndex()}>
				 {index === selectedOptionIndex ? <Icons.SelectHit/> : <Icons.SelectNormal />}
	          <span>{getSafe(() => language[opt.label], opt.label)}</span>
	        </div>
	    )}
	  </div>
    );
  }

  handleClickOption = (opt, index) => {
    const { selectedOptionIndex } = this.state;
    if(index !== selectedOptionIndex) {
      this.setState({ selectedOptionIndex: index })
      this.props.onChange(opt);
    }	
  }

  getSelectedOption = () => {
    return this.state.options?.[this.state.selectedOptionIndex];
  }
  

  componentDidMount() {
    const { options } = this.props;
    if(options) {
      this.setState({ options })
    } else {
      this.initOptions(this.props.type);
    }
  }
}

RadioOptions.defaultProps = {
  direction: 'horizontal',
  options: null,
  onChange: () => {},
  // innerRef: () => {},
}

export default connect(
    state => ({
      language: state.app.language,
    })
)(RadioOptions);